"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayConfiguration = void 0;
var react_1 = __importDefault(require("react"));
var Content_styles_1 = require("./Content.styles");
var displayConfiguration = {
    width: 250,
    height: 50,
    arrowOffsetX: 0,
    arrowOffsetY: 0,
    contentOffsetX: 0,
    contentOffsetY: 0,
    color: '',
    title: ''
};
exports.displayConfiguration = displayConfiguration;
var Content = function (_a) {
    var title = _a.title, persist = _a.persist, direction = _a.direction, showArrow = _a.showArrow, closeCallback = _a.closeCallback, render = _a.render, rest = __rest(_a, ["title", "persist", "direction", "showArrow", "closeCallback", "render"]);
    return (react_1.default.createElement(Content_styles_1.Styles, { direction: direction, showArrow: showArrow, top: rest.top, left: rest.left, arrowPosition: rest.arrowPosition, width: rest.width, height: rest.height, color: rest.color, arrowOffsetX: rest.arrowOffsetX, arrowOffsetY: rest.arrowOffsetY },
        title && react_1.default.createElement(Content_styles_1.Title, null, title),
        persist && (react_1.default.createElement(Content_styles_1.CloseButton, { onClick: closeCallback },
            react_1.default.createElement(Content_styles_1.CloseIcon, null))),
        render()));
};
Content.defaultProps = __assign(__assign({}, displayConfiguration), { persist: false });
exports.default = Content;
